import React from 'react';
import Download from '@mui/icons-material/Download';
import { Button } from '@/ui';
import toast from 'react-hot-toast';

interface ExportPropertySetsButtonProps {
  propertySetsValues: Record<string, unknown>;
}

const ExportPropertySetsButton: React.FC<ExportPropertySetsButtonProps> = ({ propertySetsValues }) => {
  const handleExport = () => {
    navigator.clipboard.writeText(JSON.stringify(propertySetsValues, null, 2)).then(() =>
      toast.success('Property Sets copied to clipboard!', {
        position: 'top-center',
        duration: 3000,
        className: 'zuul-toaster',
      })
    );
  };

  return (
    <Button type='button' color='secondary' onClick={handleExport} startIcon={<Download />}>
      Export
    </Button>
  );
};

export default ExportPropertySetsButton;
